export const FACULTY_2_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Faculty Members",
  },

  DEFAULT_ROW: {
    id: "1",
    title_1: "",
    title_1_color: "#FFFFFF",
    mobile_title_1_color: "#FFFFFF",
    title_2: "",
    title_2_color: "#00D4EB",
    horizontal_stripe_color: "#FFFFFF",
    designation: "",
    designation_color: "#FFFFFFCC",
    mobile_designation_color: "#FFFFFFCC",
    logo_1: "",
    logo_1_alt: "Logo",
    logo_2: "",
    logo_2_alt: "Logo",
    description_title: "",
    description_title_color: "#4CECFA",
    description: "",
    description_color: "rgba(255, 255, 255, 0.9)",
    desktop_bg_image: "",
    mobile_bg_image: "",
    alt_image: "Faculty",
    description_background_color: "#242424",
    priority: 1,
    status: true,
  },

  FACULTY_FIELDS_CONFIG: [
    {
      fieldName: "layout_variant",
      label: "Layout Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Layout Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1 (Default)", value: "variant_1" },
        { label: "Variant 2 (Poppins + Maroon CTA)", value: "variant_2" },
      ],
    },
    {
      fieldName: "title_1",
      label: "Title 1",
      value: "Led by Visionaries,",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 1",
      required: false,
      defaultValue: "Led by Visionaries,",
    },
    {
      fieldName: "title_1_color",
      label: "Title 1 Color",
      value: "rgba(255, 255, 255, 0.8)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title 1 Color (e.g., #FFFFFF)",
      defaultValue: "rgba(255, 255, 255, 0.8)",
    },
    {
      fieldName: "title_2",
      label: "Title 2",
      value: "Built for You",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 2",
      required: false,
      defaultValue: "Built for You",
    },
    {
      fieldName: "title_2_gradient_start_color",
      label: "Title 2 Gradient Start Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_2_gradient_end_color",
      label: "Title 2 Gradient End Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#02A7B6",
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "title_2_gradient_angle",
      label: "Title 2 Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 90deg, 180deg)",
      defaultValue: "90deg",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Left Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Left Navigation Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "left_navigation_icon_alt",
      label: "Left Navigation Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for left navigation icon",
      required: false,
      defaultValue: "Left navigation",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Right Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Right Navigation Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "right_navigation_icon_alt",
      label: "Right Navigation Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for right navigation icon",
      required: false,
      defaultValue: "Right navigation",
    },
    {
      fieldName: "range_color",
      label: "Range Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Range Color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_text",
      label: "CTA Text",
      value: "Download Brochure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Text",
      required: false,
      defaultValue: "Download Brochure",
    },
    {
      fieldName: "cta_button_color",
      label: "CTA Button Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA Button Color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Text Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA Text Color",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "auto_scroll_frequency",
      label: "Auto Scroll Frequency (milliseconds)",
      value: 5000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter auto scroll frequency in ms (e.g., 5000)",
      required: false,
      defaultValue: 5000,
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Background Color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "status",
      label: "Faculty Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Faculty Section",
      defaultValue: false,
    },
  ],

  // Metadata: Faculty Members
  METADATA_FIELDS: [
    {
      header: "Title 1",
      fieldName: "title_1",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 1 (e.g., name)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Title 1 Color",
      fieldName: "title_1_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title 1 color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Title 1 Color (Mobile)",
      fieldName: "mobile_title_1_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile title 1 color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Title 2",
      fieldName: "title_2",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 2 (e.g., qualification)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Title 2 Color",
      fieldName: "title_2_color",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title 2 color (e.g., #00D4EB)",
      defaultValue: "#00D4EB",
    },
    {
      header: "Horizontal Stripe Color",
      fieldName: "horizontal_stripe_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter stripe color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Designation",
      fieldName: "designation",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Designation",
      required: false,
      defaultValue: "",
    },
    {
      header: "Designation Color",
      fieldName: "designation_color",
      value: "rgba(255, 255, 255, 0.8)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter designation color",
      defaultValue: "rgba(255, 255, 255, 0.8)",
    },
    {
      header: "Designation Color (Mobile)",
      fieldName: "mobile_designation_color",
      value: "rgba(255, 255, 255, 0.8)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile designation color",
      defaultValue: "rgba(255, 255, 255, 0.8)",
    },
    {
      header: "Logo 1",
      fieldName: "logo_1",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Logo 1",
      required: false,
      defaultValue: "",
    },
    {
      header: "Logo 1 Alt Text",
      fieldName: "logo_1_alt",
      value: "Logo",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Logo 1 alt text",
      required: false,
      defaultValue: "Logo",
    },
    {
      header: "Logo 2",
      fieldName: "logo_2",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Logo 2",
      required: false,
      defaultValue: "",
    },
    {
      header: "Logo 2 Alt Text",
      fieldName: "logo_2_alt",
      value: "Logo",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Logo 2 alt text",
      required: false,
      defaultValue: "Logo",
    },
    {
      header: "Description Title",
      fieldName: "description_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Description Title",
      required: false,
      defaultValue: "",
    },
    {
      header: "Description Title Color",
      fieldName: "description_title_color",
      value: "#4CECFA",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description title color (e.g., #4CECFA)",
      defaultValue: "#4CECFA",
    },
    {
      header: "Description",
      fieldName: "description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: false,
      defaultValue: "",
    },
    {
      header: "Description Color",
      fieldName: "description_color",
      value: "rgba(255, 255, 255, 0.9)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color",
      defaultValue: "rgba(255, 255, 255, 0.9)",
    },
    {
      header: "Desktop Background Image",
      fieldName: "desktop_bg_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Background Image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Mobile Background Image",
      fieldName: "mobile_bg_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Background Image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Alt Image Text",
      fieldName: "alt_image",
      value: "Faculty",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
      required: false,
      defaultValue: "Faculty",
    },
    {
      header: "Description Background Color",
      fieldName: "description_background_color",
      value: "#242424",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description background color",
      defaultValue: "#242424",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: true,
    },
  ],
};
